import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { ArrowRight } from 'lucide-react';
import { mockProducts } from '../data/mock';

const Products = () => {
  return (
    <section id="produits" className="py-20 bg-cream">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-burgundy mb-6">
            Nos Produits
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-4">
            Vente au détail et en volume pour particuliers et professionnels
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {mockProducts.map((product, index) => (
            <Card 
              key={product.id}
              className="overflow-hidden bg-white border-2 border-gray-100 hover:border-burgundy/30 hover:shadow-2xl transition-all duration-300 group animate-fade-in-up"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Product Image */}
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={`${product.image}?w=600&q=80`}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                
                {/* Badge */}
                {product.available && (
                  <Badge className="absolute top-4 right-4 bg-green-600 text-white border-0">
                    Disponible
                  </Badge>
                )}
              </div>

              {/* Product Info */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-burgundy transition-colors">
                  {product.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {product.description}
                </p>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA to Products Page */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            📌 Disponibilité selon la production par vague. Les précommandes sont recommandées.
          </p>
          <Link to="/produits">
            <Button 
              size="lg"
              className="bg-burgundy hover:bg-burgundy-dark text-white gap-2 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              Voir tous les produits et commander
              <ArrowRight size={20} />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Products;
